exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".hapyak-annotation-container .mute-toggle .icon{color:black;font-size:6em;opacity:0.2;transition:opacity 0.125ms ease}.hapyak-annotation-container .mute-toggle .icon:hover{opacity:0.6}\n", ""]);

